import React from 'react';
import { FadeIn } from './FadeIn';

export const WhatWeDo = () => {
  return (
    <section id="what-we-do" className="relative py-32 md:py-48 bg-c-cream text-c-dark">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8">
          <div className="lg:col-span-4">
            <FadeIn>
              <h2 className="text-xs font-medium tracking-super-wide uppercase text-c-dark/40 mb-4">What CHRSMA Is</h2>
              <div className="divider-gradient w-12"></div>
            </FadeIn>
          </div>
          <div className="lg:col-span-7 lg:col-start-6">
            <FadeIn delay={0.1}>
              <h3 className="text-3xl md:text-5xl font-light text-c-dark leading-[1.2] mb-12">
                We are a strategic branding and positioning company built for <span className="font-serif-italic text-c-mauve/80">operators.</span>
              </h3>
            </FadeIn>
            <FadeIn delay={0.2}>
              <div className="flex flex-col gap-8 text-lg text-c-dark/70 font-light leading-relaxed">
                <p>
                  Most branding agencies focus on aesthetics first. We focus on truth first. Your market position, your core thesis, and your operational reality must align before a single pixel is pushed or a tagline is written.
                </p>
                <p>
                  We partner with founders and executives to distill complex business models into clear, compelling narratives. We don't just build brands; we build strategic assets that drive clarity, align teams, and accelerate growth.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>
  );
};
